module.exports = __webpack_public_path__ + "static/media/self.4ee65fc5.jpg";